import styled from '@emotion/styled';

export const FooterWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`;

export const FooterSpan = styled.span<{ color?: string }>`
  font-weight: 500;
  color: ${(props) => (props.color ? props.color : props.theme.color.blue.default)};
  padding-right: 5px;

  white-space: nowrap;
  &:last-of-type {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const ContentTitle = styled.div`
  font-size: 16px;
  font-weight: 600;

  overflow: hidden;
  text-overflow: ellipsis;

  height: 91px;
  line-height: 21px;
  max-height: 42px;

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;
